








import { Component, mixins } from '@niknevis/vue-modules'
import AdminRoleSearch from '@/modules/role/components/admin/AdminRoleSearch.vue'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'

@Component({
  components: {
    AdminRoleSearch
  }
})
export default class AdminRoleSearchFilter extends mixins(FilterEntitySearchMixin) {

}
